import { Icon, LogOutIcon, Pane, StatusIndicator, Text } from 'evergreen-ui';
import { FC, useMemo, useState } from 'react';
import styled from 'styled-components';
import crown from '../assets/crown.png';
import app_android from '../assets/app_android.png';
import app_ios from '../assets/app_ios.png';

const StyledList = styled(Pane)`
  display: flex;
  flex-direction: column;
  position: absolute;
  overflow: auto;
  max-height: calc(100% - 64px);
  width: 100%;
  margin-top: 64px;
  padding-top: 10px;
  padding-bottom: 60px;
`;
const StyledSeparator = styled.div`
  display: flex;
  margin: 0 25px;
  height: 1px;
  background: #3e4143;
`;
const StyledButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  background: #e78850;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 10px;

  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  &.disabled {
    cursor: not-allowed;
    background: #a47d66;
    &:hover {
      opacity: 1;
    }
  }
`;
const StyledInput = styled.input`
  display: flex;
  height: 52px;
  background: #2b2d2e;
  font-size: 15px;
  font-weight: 600;
  color: #858789;
  border-radius: 8px;
  margin-top: 10px;
  padding: 0 15px;
  border: none;
`;
const StyledButtonRelink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  background: #2b2d2e;
  font-size: 15px;
  font-weight: 600;
  color: #e78850;
  border-radius: 8px;
  margin-top: 10px;

  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`;

const Account = ({
  username,
  isLinked,
  subscriptionProgress,
  expiration,
  androidURL,
  iosURL,
  callSupport,
  sendInvoice,
  linkAccount,
  shouldShowPaymentOptions,
  price,
  logout,
}) => {
  const [email, setEmail] = useState('');
  const updateEmail = e => {
    setEmail(e.target.value);
  };
  const sendMail = () => {
    if (email?.length > 5) sendInvoice(email);
  };

  return (
    <Pane background="#1F2021" position="relative" display="flex" flex={1} height="100%" flexDirection="column">
      <Text
        color="#FFFFFF"
        background="#1F2021"
        boxShadow="0 0 14px 12px #1F2021"
        fontSize={22}
        fontWeight={900}
        padding={30}
        paddingBottom={10}
        textAlign="center"
        marginBottom={15}
        zIndex={2}
      >
        My Account
      </Text>
      <StyledList>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '30px 0',
          }}
        >
          <img alt="logo" src={crown} />
          <p style={{ color: '#FFFFFF' }}>{username}</p>
          {isLinked ? (
            <StatusIndicator color="#E78850">
              <span
                style={{
                  color: '#E78850',
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Linked
              </span>
            </StatusIndicator>
          ) : (
            <StatusIndicator color="#3E4143">
              <span
                style={{
                  color: '#65696C',
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Disconnected
              </span>
            </StatusIndicator>
          )}
        </div>
        {!isLinked && (
          <Pane paddingBottom={30} paddingX={25}>
            <StyledButtonRelink onClick={linkAccount}>LINK ACCOUNT</StyledButtonRelink>
            <p style={{ fontSize: 13, color: '#A7AAAC', textAlign: 'center' }}>*REQUIRED</p>
          </Pane>
        )}
        <div
          style={{
            background: '#3E4143',
            minHeight: 4,
            height: 4,
            width: 'calc(100% - 50px)',
            borderRadius: 4,
            position: 'relative',
            margin: '15px 25px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              height: 5,
              width: subscriptionProgress + '%',
              background: '#E78850',
            }}
          ></div>
        </div>
        <Pane display="flex" justifyContent="space-between" paddingX={25} paddingY={10}>
          <p style={{ color: '#E9EBED', fontSize: 14, fontWeight: 500 }}>Subscription</p>
          <p style={{ color: '#A7AAAC', fontSize: 14, fontWeight: 400 }}>{expiration}</p>
        </Pane>
        {shouldShowPaymentOptions && (
          <Pane
            style={{
              margin: '-10px 25px 25px',
            }}
          >
            <p
              style={{
                color: '#A7AAAC',
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              Enter the email address where you would like to recieve an invoice
            </p>
            <Pane
              borderTop="1px dashed #3A3D3E"
              display="flex"
              flexDirection="column"
              paddingY={10}
              marginTop={25}
              color="#A7AAAC"
              fontSize={13}
              fontWeight={500}
            >
              <p>Invoice item:</p>
              <Pane display="flex" justifyContent="space-between">
                <p>1x Month Subscription</p>
                <p style={{ color: '#E78850' }}>£{price ?? ' -'}</p>
              </Pane>
              <StyledInput placeholder="Enter email" type="email" onChange={updateEmail}></StyledInput>
              <StyledButton onClick={sendMail} className={email?.length > 5 ? '' : 'disabled'}>
                Send Invoice
              </StyledButton>
            </Pane>
          </Pane>
        )}
        <StyledSeparator />
        {(androidURL || iosURL) && (
          <>
            <Pane display="flex" flexDirection="column" paddingX={25} paddingY={10}>
              <p style={{ color: '#E9EBED', fontSize: 14, fontWeight: 500 }}>Download</p>
              <Pane display="flex">
                {androidURL && (
                  <a href={androidURL} target="_blank" rel="noreferrer">
                    <img alt="Android APP" src={app_android} style={{ marginRight: iosURL ? 5 : 0 }} />
                  </a>
                )}
                {iosURL && (
                  <a href={iosURL} target="_blank" rel="noreferrer">
                    <img alt="iOS APP" src={app_ios} style={{ marginLeft: androidURL ? 5 : 0 }} />
                  </a>
                )}
              </Pane>
              <p style={{ color: '#A7AAAC', fontSize: 13, fontWeight: 500 }}>
                Download our app to recieve notifications when shifts are accepted.
              </p>
            </Pane>
            <StyledSeparator />
          </>
        )}
        <Pane display="flex" justifyContent="space-between" paddingX={25} paddingY={10}>
          <p style={{ color: '#E9EBED', fontSize: 14, fontWeight: 500 }}>Support</p>
          <p style={{ color: '#E78850', fontSize: 14, fontWeight: 600, cursor: 'pointer' }} onClick={callSupport}>
            CONTACT
          </p>
        </Pane>
        <StyledSeparator />
        <Pane display="flex" justifyContent="space-between" paddingX={25} paddingY={10}>
          <p style={{ color: '#E9EBED', fontSize: 14, fontWeight: 500 }}>Logout</p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#E78850',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
            onClick={logout}
          >
            <Icon icon={LogOutIcon} />
          </div>
        </Pane>
      </StyledList>
      <Pane
        position="absolute"
        bottom={0}
        height={0}
        width="100%"
        boxShadow="0 0 14px 22px #1F2021"
        background="#1F2021"
      />
    </Pane>
  );
};

export default Account;
